module.exports = __webpack_public_path__ + "static/media/doubleSink270.af3f48ec.png";